export default __webpack_public_path__ + "static/media/ndzjh.e52534d9.png";